import http from "@/utils/request";

const download = {
  getDownloadHistory: (data) =>
    http.sendRequest({
      METHOD_NAME: "supplychainStockoutService.queryDownloadHistory",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        12000001: "未找到用户",
      },
    }),
  queryImportHistory: (data) =>
    http.sendRequest({
      METHOD_NAME: "supplychainStockoutService.queryImportHistory",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        12000001: "未找到用户",
      },
    }),
  submitImportTask: (data) =>
    http.sendRequest({
      METHOD_NAME: "supplychainStockoutService.submitImportTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        12000001: "未找到用户",
      },
    }),
};

export default download;
